import * as React from 'react';
import { DecoratorNode } from 'lexical';
import BlockViewerComponent from './BlockViewerComponent';

export class BlockViewerNode extends DecoratorNode {
  static getType() {
    return 'block';
  }

  static clone(node) {
    return new BlockViewerNode(node.__data, node.__key);
  }

  static importJSON(serializedNode) {
    return $createBlockViewerNode(serializedNode.data);
  }

  constructor(data, options, key) {
    super(key);
    this.__data = data;
  }

  exportJSON() {
    return {
      data: this.__data,
      type: 'block',
      version: 1
    };
  }

  createDOM() {
    const elem = document.createElement('span');
    elem.style.display = 'inline-block';
    elem.style.maxWidth = '100%';
    return elem;
  }

  updateDOM() {
    return false;
  }

  decorate() {
    return <BlockViewerComponent data={this.__data} nodeKey={this.__key} />;
  }
}

export function $createBlockViewerNode(data, opts = {}) {
  return new BlockViewerNode(data, opts);
}

export function $isBlockViewerNode(node) {
  return node instanceof BlockViewerNode;
}
